import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  /**
   * その他/調整テンプレート一覧を取得
   * @returns {Promise} - { earningTemplates: { data: EarningTemplate[] } }
   */
  getEarningTemplates() {
    return axiosIns.get('/admin/earning_templates')
  },

  /**
   * その他/調整テンプレートを作成
   * @param {Object} params
   * @param {string} params.name - テンプレート名
   * @param {{ name: string, amount: number }[]} params.items - クロージングで列として挿入する項目(順序どおり)。amountはデフォルト金額
   * @param {number} [params.position] - 表示順
   * @returns {Promise} - { earningTemplate: { data: EarningTemplate } }
   */
  createEarningTemplate({ name, items, position }) {
    const params = snakecaseKeys({
      earningTemplate: { name, items, position },
    })

    return axiosIns.post('/admin/earning_templates', params)
  },

  /**
   * その他/調整テンプレートを更新
   * @param {Object} params
   * @param {number} params.id - テンプレートID
   * @param {string} [params.name] - テンプレート名
   * @param {{ name: string, amount: number }[]} [params.items] - 項目(順序どおり)
   * @param {number} [params.position] - 表示順
   * @returns {Promise} - { earningTemplate: { data: EarningTemplate } }
   */
  updateEarningTemplate({
    id, name, items, position,
  }) {
    const params = snakecaseKeys({
      earningTemplate: { name, items, position },
    })

    return axiosIns.put(`/admin/earning_templates/${id}`, params)
  },

  /**
   * その他/調整テンプレートを削除
   * @param {number} id - テンプレートID
   * @returns {Promise}
   */
  deleteEarningTemplate(id) {
    return axiosIns.delete(`/admin/earning_templates/${id}`)
  },
}
